import React from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUser, faVenusMars, faUsers } from "@fortawesome/free-solid-svg-icons";
import { services } from "./services";

library.add(faUser, faVenusMars, faUsers);

function Services() {
    return (
       <section className="bg-[#eaebec]">
         <div className="py-12 text-black max-w-[1280px] mx-auto px-4 2xl:px-0">
            {/* Section Header */}
            <div className="flex justify-center items-center mb-20">
                <div className="text-center">
                    <h2 className="text-2xl md:text-3xl mb-2 font-semibold">Our Services</h2>
                    <div className="border-b-4 border-green-600 w-[90px] mx-auto" />
                </div>
            </div>

            {/* Services Grid */}
            <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                {services.map((service, idx) => (
                    <div key={idx} className="flex flex-col items-center text-center">
                        <div className="w-[200px] h-[200px] rounded-full overflow-hidden mb-4">
                            <img
                                className="w-full h-full object-cover"
                                src={service.image.src}
                                alt={service.image.alt}
                            />
                        </div>
                        <h3 className="text-lg md:text-xl font-semibold mt-4">{service.name}</h3>
                        <p className="w-[80%] mx-auto text-sm mt-2">{service.description}</p>
                    </div>
                ))}
            </div>

        </div>
       </section>
    );
}

export default Services;
